import React from 'react';

import { TextField } from '@material-ui/core';
import { NumericFormat } from 'react-number-format';

type MonetaryValueFieldProps = Omit<
  React.ComponentProps<typeof TextField>,
  'defaultValue' | 'type' | 'value' | 'onChange'
> & {
  value?: string | number;
  onChange?: (value: number | null) => void;
};

export default function MonetaryValueField(props: MonetaryValueFieldProps) {
  const { inputRef, onChange, value, ...rest } = props;

  return (
    <NumericFormat
      thousandSeparator="."
      decimalSeparator=","
      prefix="R$ "
      decimalScale={2}
      fixedDecimalScale
      allowNegative={false}
      getInputRef={inputRef}
      customInput={TextField}
      value={value}
      onValueChange={values => {
        onChange?.(values.floatValue ?? null);
      }}
      {...rest}
    />
  );
}
